import {LinkNode} from 'common/components/breadcrumbs/types';

export enum FullScreenSignupStepId {
  JOIN_EXISTING_ORG = 0,
  CREATE_ORG = 1,
  CREATE_PROJECT = 2,
  CONGRATULATIONS = 3,
}

export const LAST_STEP = FullScreenSignupStepId.CONGRATULATIONS;
export const PRE_CREATE_STEPS = 1;

export type SignupLinkNode = LinkNode & {
  stepIndex?: FullScreenSignupStepId;
};
